import { useEventEmitter, useMutation, useSession } from 'common/hooks';
import { UseMutationOptions } from 'common/types/Api.type';
import { updatePostApi } from '../posts.service';

export const useUpdatePost = (options: UseMutationOptions = {}) => {
  const { account: user } = useSession();

  const { emitWithSettledAfter } = useEventEmitter('PostsModified');

  return useMutation(updatePostApi, {
    showSuccessSnackbar: true,
    onSuccess: ({ data }) => {
      emitWithSettledAfter(3000, { data, organizationId: user?.organizationId });
    },
    ...options,
  });
};
